export function ReferralsSkeleton() {

    function render() {
        return /*html*/`
        <!-- Skeleton Table Rows -->
        <tr>
        <td class="size-px whitespace-nowrap pe-4 py-3">
            <div class="grow">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-3/4"></span>
            </div>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/2"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/3"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/4"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-2/3"></span>
        </td>
        </tr>

        <tr>
        <td class="size-px whitespace-nowrap pe-4 py-3">
            <div class="grow">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-3/4"></span>
            </div>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/2"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/3"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-1/4"></span>
        </td>
        <td class="size-px whitespace-nowrap px-4 py-3">
            <span class="block h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-2/3"></span>
        </td>
        </tr>
        `;
    }

    return {
        render,
    };
}
